import * as fromDatatype from '../datatype-library';

export interface bl_fi_deposit_register_txn_line_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    hdr_guid: fromDatatype.GuidDataFieldInterface;
    txn_category_guid: fromDatatype.GuidDataFieldInterface;
    gl_code_guid: fromDatatype.GuidDataFieldInterface;
    jrnl_hdr_guid: fromDatatype.GuidDataFieldInterface;
    cashbook_txn_line_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    date_txn: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    txn_type: fromDatatype.VarcharDatatypeInterface;
    deposit_register_txn_type_code: fromDatatype.VarcharDatatypeInterface;
    gl_code_code: fromDatatype.VarcharDatatypeInterface;
    gl_code_desc: fromDatatype.VarcharDatatypeInterface;
    currency: fromDatatype.VarcharDatatypeInterface;
    reference_no: fromDatatype.VarcharDatatypeInterface;
    remarks: fromDatatype.VarcharDatatypeInterface;
    posting_status: fromDatatype.VarcharDatatypeInterface;
    posting_journal: fromDatatype.VarcharDatatypeInterface;
    posting_cashbook: fromDatatype.VarcharDatatypeInterface;
    namespace: fromDatatype.VarcharArrayDatatypeInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    amount: fromDatatype.NumericDatatypeInterface;
    amount_principal: fromDatatype.NumericDatatypeInterface;
    amount_interest: fromDatatype.NumericDatatypeInterface;
    amount_total: fromDatatype.NumericDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    description: fromDatatype.VarcharDatatypeInterface;
}


export class bl_fi_deposit_register_txn_line_RowClass implements bl_fi_deposit_register_txn_line_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    hdr_guid: fromDatatype.GuidDataFieldInterface;
    txn_category_guid: fromDatatype.GuidDataFieldInterface;
    gl_code_guid: fromDatatype.GuidDataFieldInterface;
    jrnl_hdr_guid: fromDatatype.GuidDataFieldInterface;
    cashbook_txn_line_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    date_txn: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    txn_type: fromDatatype.VarcharDatatypeInterface;
    deposit_register_txn_type_code: fromDatatype.VarcharDatatypeInterface;
    gl_code_code: fromDatatype.VarcharDatatypeInterface;
    gl_code_desc: fromDatatype.VarcharDatatypeInterface;
    currency: fromDatatype.VarcharDatatypeInterface;
    reference_no: fromDatatype.VarcharDatatypeInterface;
    remarks: fromDatatype.VarcharDatatypeInterface;
    posting_status: fromDatatype.VarcharDatatypeInterface;
    posting_journal: fromDatatype.VarcharDatatypeInterface;
    posting_cashbook: fromDatatype.VarcharDatatypeInterface;
    namespace: fromDatatype.VarcharArrayDatatypeInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    amount: fromDatatype.NumericDatatypeInterface;
    amount_principal: fromDatatype.NumericDatatypeInterface;
    amount_interest: fromDatatype.NumericDatatypeInterface;
    amount_total: fromDatatype.NumericDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    description: fromDatatype.VarcharDatatypeInterface;
}
